"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ApiBadgeCount;
var _react = _interopRequireDefault(require("react"));
var _withAPIData = require("../api/withAPIData");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _index = _interopRequireDefault(require("axios/index"));
function ApiBadgeCount(_ref) {
  var url = _ref.url,
    axiosInstance = _ref.axiosInstance,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? "warning" : _ref$color;
  return /*#__PURE__*/_react["default"].createElement(_withAPIData.WithAPIData, {
    axiosInstance: axiosInstance,
    url: url
  }, function (_ref2) {
    var data = _ref2.data,
      loading = _ref2.loading;
    return loading === false && data.count > 0 && /*#__PURE__*/_react["default"].createElement("span", {
      className: "badge badge-".concat(color),
      style: {
        padding: "4px 6px"
      }
    }, data.count);
  });
}
ApiBadgeCount.propTypes = {
  axiosInstance: _propTypes["default"].func.isRequired,
  url: _propTypes["default"].string.isRequired
};
ApiBadgeCount.defaultProps = {
  axiosInstance: _index["default"]
};